import React from "react"
import {
  IoLogoJavascript,
  IoLogoHtml5,
  IoLogoCss3,
  IoLogoSass,
  IoLogoWordpress,
  IoLogoFigma,
  IoLogoReact,
} from "react-icons/io5"
import {
  SiGatsby,
  SiPhp,
  SiAdobeillustrator,
  SiAdobephotoshop,
  SiAdobexd,
} from "react-icons/si"

const skillset = [
  {
    id: 1,
    category: "front-end",
    icon: <IoLogoHtml5></IoLogoHtml5>,
    text: "HTML",
    proficiency: 100,
    started: "2018-10-01",
  },
  {
    id: 2,
    category: "front-end",
    icon: <IoLogoCss3></IoLogoCss3>,
    text: "CSS",
    proficiency: 100,
    started: "2018-10-01",
  },
  {
    id: 3,
    category: "front-end",
    icon: <IoLogoSass></IoLogoSass>,
    text: "Sass",
    proficiency: 100,
    started: "2019-02-01",
  },
  {
    id: 4,
    category: "front-end",
    icon: <IoLogoJavascript></IoLogoJavascript>,
    text: "JavaScript",
    proficiency: 90,
    started: "2018-11-01",
  },
  {
    id: 5,
    category: "front-end",
    icon: <SiGatsby></SiGatsby>,
    text: "Gatsby.js",
    proficiency: 60,
    started: "2021-03-01",
  },
  {
    id: 6,
    category: "cms",
    icon: <IoLogoWordpress></IoLogoWordpress>,
    text: "WordPress",
    proficiency: 90,
    started: "2017-08-01",
  },
  {
    id: 7,
    category: "back-end",
    icon: <SiPhp></SiPhp>,
    text: "PHP",
    proficiency: 50,
    started: "2019-02-01",
  },
  {
    id: 8,
    category: "design",
    icon: <SiAdobeillustrator></SiAdobeillustrator>,
    text: "Adobe Illustrator",
    proficiency: 100,
    started: "2018-02-01",
  },
  {
    id: 9,
    category: "design",
    icon: <SiAdobephotoshop></SiAdobephotoshop>,
    text: "Adobe Photoshop",
    proficiency: 60,
    started: "2018-05-01",
  },
  {
    id: 10,
    category: "design",
    icon: <IoLogoFigma></IoLogoFigma>,
    text: "Figma",
    proficiency: 70,
    started: "2020-08-01",
  },
  {
    id: 11,
    category: "cms",
    icon: "",
    text: "MicroCMS",
    proficiency: 70,
    started: "2021-03-01",
  },
  {
    id: 12,
    category: "front-end",
    icon: <IoLogoReact></IoLogoReact>,
    text: "React.js",
    proficiency: 40,
    started: "2021-02-01",
  },
  {
    id: 12,
    category: "design",
    icon: <SiAdobexd></SiAdobexd>,
    text: "Adobe XD",
    proficiency: 70,
    started: "2019-08-01",
  },
]

export default skillset
